import { isWildebeestOrigin } from '../../../utils/constants'

const initialState = {
  isWildebeest: isWildebeestOrigin(),
}

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}
